import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class VentaService {
	private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;
	public factelec_api: String;

	constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
		this.factelec_api = environment.factelec_api;
	}

	getAll(queryString: String = "") {
		let url = this.host_api + '/ventas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	

	getAllByProducto(queryString: String = "") {
		let url = this.host_api + '/ventas/filterByProducto' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getTotales(queryString: String = "") {
		let url = this.host_api + '/ventas/totales' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getVentasNetasByPeriodo(queryString: String = ""){
		let url = this.host_api + '/ventas/ventasnetas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getVentasByCliente(queryString: String = ""){
		let url = this.host_api + '/ventas/ventasbycliente' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getAllDoc(qs: String) {
		let url = this.host_api + '/desktop/getAllDoc' + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	getAllByFilter(queryString: String = ""){
		let url = this.host_api + '/ventas/filter' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getAllByNotas(queryString: String = ""){
		let url = this.host_api + '/ventas/notas' + queryString;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});	
	}

	getById(id, qs: String) {
		let url = this.host_api + '/ventas/' + id + qs;
		let headers = new Headers({ 'Accept': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.get(url, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	save(Venta,qs="") {
		let url = this.host_api + '/ventas'+qs;
		let params = Venta;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	ventaElectronica(Venta) {
		let url = this.factelec_api + '/facturacion';
		let params = Venta;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));
		//headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	GetPDFElectronica(Venta) {
		let url = this.factelec_api + '/ride';
		let params = Venta;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	ReenviarElectronica(Venta) {
		let url = this.factelec_api + '/correo';
		let params = Venta;
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this.ss.getData('fact-api-token'));

		let options = new RequestOptions({ headers: headers });

		return this.http.post(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		

	}

	update(Venta) {
		let url = this.host_api + '/ventas/' + Venta.id;
		let params = JSON.stringify(Venta);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	anular(Venta) {
		let url = this.host_api + '/ventas/anulacion/' + Venta.id;
		let params = JSON.stringify(Venta);
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);

		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {	
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	delete(id) {
		var url = this.host_api + '/ventas/' + id + '/del';
		let params = {usuario_id: this.ss.getData('usuario_id')};
		let headers = new Headers({ 'Content-type': 'application/json' });
		headers.append('Authorization', "Bearer "+ this._token);
		headers.append('dbname', this.dbname);
		let options = new RequestOptions({ headers: headers });

		return this.http.put(url, params, options).map((res:Response) => {
			return this.config.onSuccessResponse(res);
		}).catch((error: any) => {
			return this.config.onErrorResponse(error);
		});		
	}

	calcularTotales(venta, tipo_comprobante_id: String, venta_detalle, IVA: number, total_pago: number) {
        venta.subtotal_iva12 = 0;
        venta.subtotal_iva0 = 0;
        venta.subt_desct_iva12 = 0;
        venta.subt_desct_iva0 = 0;
        venta.iva = 0;
        venta.total = 0;

        venta_detalle.forEach(obj => {
			if( (tipo_comprobante_id == "1" && obj.graba_iva) || tipo_comprobante_id == "4" && obj.graba_iva ){
                venta.subtotal_iva12 += parseFloat(obj.subtotal.toString());
            }else{
                venta.subtotal_iva0 += parseFloat(obj.subtotal.toString());
            }
        });

        let desc_porcent = (venta.desct_porcent / 100);
        desc_porcent = Math.round(desc_porcent * 100) / 100;
        venta.desct_valor = (venta.subtotal_iva0 + venta.subtotal_iva12) * desc_porcent;
        venta.subt_desct_iva0 = venta.subtotal_iva0 - (desc_porcent * venta.subtotal_iva0);
        venta.subt_desct_iva12 = venta.subtotal_iva12 - (desc_porcent * venta.subtotal_iva12);

        if( tipo_comprobante_id == "1" || tipo_comprobante_id == "4" ){
            venta.iva = Math.round((venta.subt_desct_iva12 * IVA) * 100) / 100;
        }else{
            venta.iva = Math.round(venta.subt_desct_iva12 * 100) / 100;
        }
        
        venta.total = venta.subt_desct_iva12 + venta.subt_desct_iva0 + venta.iva;

        venta.cambio = (total_pago > venta.total?(total_pago - venta.total):0);
        venta.cambio = Math.round(venta.cambio * 100) / 100;

        return venta;
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/venta.service.ts